"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const abortcontroller_ponyfill_1 = require("./abortcontroller-ponyfill");
class NullSignal {
}
/**
 * aggregates a number of abort signals, will only fire the aggregated
 * abort if all of the input signals have been aborted
 */
class AggregateAbortController {
    constructor() {
        this.signals = new Set();
        this.abortController = new abortcontroller_ponyfill_1.AbortController();
    }
    /**
     * @param {AbortSignal} [signal] optional AbortSignal to add. if falsy,
     *  will be treated as a null-signal, and this abortcontroller will no
     *  longer be abortable.
     */
    //@ts-ignore
    addSignal(signal = new NullSignal()) {
        if (this.signal.aborted) {
            throw new Error('cannot add a signal, already aborted!');
        }
        // note that a NullSignal will never fire, so if we
        // have one this thing will never actually abort
        this.signals.add(signal);
        if (signal.aborted) {
            // handle the abort immediately if it is already aborted
            // for some reason
            this.handleAborted(signal);
        }
        else if (typeof signal.addEventListener === 'function') {
            signal.addEventListener('abort', () => {
                this.handleAborted(signal);
            });
        }
    }
    handleAborted(signal) {
        this.signals.delete(signal);
        if (this.signals.size === 0) {
            this.abortController.abort();
        }
    }
    get signal() {
        return this.abortController.signal;
    }
    abort() {
        this.abortController.abort();
    }
}
exports.default = AggregateAbortController;
